module.exports = __webpack_public_path__ + "img/pPlus.87e2b925.png";